
import React, { useState } from 'react';
import { Modal, Form, InputGroup, Button } from 'react-bootstrap';

const AddMenuItemModal = ({ show, onHide, onAdd }) => {
  const [newMenuItem, setNewMenuItem] = useState({ item: '', price: '' });

  const handleAdd = () => {
    if (!newMenuItem.item.trim() || !newMenuItem.price) {
      alert('Please enter both item name and price');
      return;
    }
    
    const price = parseInt(newMenuItem.price) || 0;
    if (price <= 0) {
      alert('Price must be greater than 0');
      return;
    }
    
    onAdd(newMenuItem);
    setNewMenuItem({ item: '', price: '' });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Menu Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Item Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g., Chicken Biryani"
              value={newMenuItem.item}
              onChange={(e) => setNewMenuItem({...newMenuItem, item: e.target.value})}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Additional Price Per Person (PKR)</Form.Label>
            <InputGroup>
              <InputGroup.Text>Rs</InputGroup.Text>
              <Form.Control
                type="number"
                placeholder="0"
                value={newMenuItem.price}
                onChange={(e) => setNewMenuItem({...newMenuItem, price: e.target.value})}
                min="0"
                required
              />
            </InputGroup>
            <Form.Text className="text-muted">
              This price will be added to the Food Bill per person
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleAdd}>
          Add Item
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMenuItemModal;